import React, { useEffect, useState } from "react"
import {Row, Col, Card, CardBody, CardHeader} from 'reactstrap'
import Rating from 'ui/rating'
import ApiFetcher from 'lib/api_fetcher'
import time from 'i18n/time'

const fetchReviews = (url) => {
  return new ApiFetcher({
    key: 'reviews',
    endpoint: url,
    method: 'GET'
  }).call()
}

const GoogleReviews = (props) => {
  const {destination, url} = props
  const [data, setData] = useState()

  useEffect(() => {
    fetchReviews(url)
      .then((res) => {
        setData(res)
      })
  }, [])

  if (!data || !data?.rating) { return '' }

  const {placeName, rating, userRatingCount, googleMapsUri, reviews} = data

  return (
    <Row className="my-5">
      <Col>
        <h2 className="text-center mb-5">
          What do our customers think?
          <div>
            <small className="text-center fw-normal" style={{fontSize: '0.8em'}}>
              Reviews from our customers in {destination?.name}
              <span className="ms-3 text-primary">{rating} <i className="fas fa-star"/> <span className="text-muted">({userRatingCount})</span></span>
            </small>
          </div>
        </h2>
      </Col>
      <Row className="row-cols-1 row-cols-sm-3 row-cols-lg-3 gx-5">
        {reviews.slice(0, 3).map((review, index) => {
          const authorName = review.authorAttribution?.displayName || "Client";
          const authorUrl = review.authorAttribution?.uri;
          const authorPhoto = review.authorAttribution?.photoUri;
          const reviewText = review.text?.text || "";
          const reviewRating = review.rating ?? "";
          const reviewDate =
            review.relativePublishTimeDescription ||
            (review.publishTime
              ? time(review.publishTime).format("LLL")
              : "");

          return (
            <Col className="d-flex">
              <Card
                key={`${authorName}-${index}`}
                className="d-flex flex-column text-center rounded-5 shadow h-100 w-100 px-3 py-4"
              >
                {authorPhoto ? (
                  <div className="w-100 d-flex justify-content-center mb-2">
                    <img
                      src={authorPhoto}
                      alt={authorName}
                      width={100}
                      height={100}
                      style={{ borderRadius: "50%", objectFit: "cover" }}
                    />
                  </div>
                ) : null}

                {authorUrl ? (
                  <span className="fw-semibold text-primary">
                    {authorName}
                  </span>
                ) : (
                  <strong className="my-2" style={{fontSize: '1.1em'}}>{authorName}</strong>
                )}

                <Rating value={reviewRating} style={{fontSize: '2em'}}/>

                {reviewDate &&
                  <div className="text-muted">
                    {reviewDate}
                  </div>
                }

                <div className="d-flex justify-content-between mt-2 mx-3">
                  <i className="fas fa-quote-left me-1"/>
                    <div>{reviewText}</div>
                  <i className="fas fa-quote-right ms-1 d-flex align-self-end"/>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
      <Row>
        <Col className="text-center mt-5">
          <a
            style={{fontSize: '1.2em'}}
            rel={'noopener noreferrer'}
            target={'_blank'}
            href={googleMapsUri}>Discover more reviews on our profile <i className="fas fa-external-link-alt"/>
          </a>
        </Col>
      </Row>
    </Row>
  )
}

export default GoogleReviews
